import { z } from 'zod';

// Configure Zod before page modules construct schemas. This avoids its eval
// capability probe while keeping the production CSP free of `unsafe-eval`.
z.config({ jitless: true });
